import type { UserImageProps } from "@circle-react-uikit/UserImage";
import { UserImageWithFallback } from "@/react/components/shared/uikit/UserImageWithFallback";
import type { NotificationActionType } from "@circle-react/types/Notification";
import { NotificationTypeIcon } from "./NotificationTypeIcon";

export interface UserImageWithIconProps {
  action: NotificationActionType;
  name: string;
  size?: UserImageProps["size"];
  src?: string;
}

export const UserImageWithIcon = ({
  src = "",
  name,
  action,
  size = "8",
}: UserImageWithIconProps) => (
  <div className="relative mr-3 shrink-0">
    <UserImageWithFallback src={src} name={name} size={size} />
    <NotificationTypeIcon action={action} />
  </div>
);
